import { parseStaticGlb, type StaticGlbAsset } from "@endclock/shared/static-glb";

export { parseStaticGlb } from "@endclock/shared/static-glb";
export type {
  StaticGlbAsset, StaticGlbCollision, StaticGlbGeometry, StaticGlbMaterial,
  StaticGlbPrimitive, StaticGlbTexture,
} from "@endclock/shared/static-glb";

/** Focused glTF 2.0 loader for ENDCLOCK's one-mesh static GLB assets. */
export async function loadStaticGlb(url: string): Promise<StaticGlbAsset> {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Static asset request failed: ${url}`);
  const asset = parseStaticGlb(await response.arrayBuffer());
  const baseUrl = new URL(url, globalThis.location.href);
  return {
    ...asset,
    primitives: asset.primitives.map((primitive) => ({
      ...primitive,
      material: primitive.material.baseColorTexture
        ? {
            ...primitive.material,
            baseColorTexture: {
              ...primitive.material.baseColorTexture,
              uri: new URL(primitive.material.baseColorTexture.uri, baseUrl).href,
            },
          }
        : primitive.material,
    })),
  };
}
